var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00668 14.9201C8.5988 15.3282 8.59904 15.9897 9.00722 16.3976C9.4154 16.8055 10.0769 16.8052 10.4848 16.3971L12.6998 14.1805L14.9164 16.3971C15.3244 16.8051 15.986 16.8051 16.394 16.3971C16.802 15.9891 16.802 15.3275 16.394 14.9195L14.1768 12.7023L16.3929 10.4845C16.8008 10.0763 16.8006 9.41479 16.3924 9.00692C15.9843 8.59904 15.3227 8.59929 14.9148 9.00746L12.6992 11.2248L10.4836 9.00914C10.0755 8.60112 9.414 8.60112 9.00597 9.00914C8.59794 9.41716 8.59794 10.0787 9.00597 10.4867L11.2222 12.7029L9.00668 14.9201Z",
    fill: "#F95370"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 18,
    height: 18,
    rx: 5,
    stroke: "#F95370",
    strokeOpacity: 0.9,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveMark);
export default __webpack_public_path__ + "static/media/remove-mark.05f900d24e37f8017aa1c6da94f82120.svg";
export { ForwardRef as ReactComponent };